export default "__VITE_ASSET__f71dc77d__"